import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import ViewIcon from "components/CustomIcons/View.js";
import EmailIcon from "components/CustomIcons/Email.js";

import { Visibility, CreditCard, Edit, Delete } from "@material-ui/icons";
import DescriptionIcon from "@material-ui/icons/Description";
import EmailView from "@material-ui/icons/Email";

import { Tooltip } from "@material-ui/core";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import { useInactivity } from "components/Inactivity/Inactivity";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/CustomTable.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import Button from "components/CustomButtons/CustomButton";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";
import CustomModal from "components/CustomModal/Modal.js";
import SweetAlert from "react-bootstrap-sweetalert";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import stylesAlerts from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import {
  getQuotesByClient,
  deleteQuoteAPI,
  print
} from "views/Services/OrdersService";

import { sendEmailAgent } from "views/Services/ClientService";

import {
  checkIfIsKiosko,
  sanatizeMessageHtml,
} from "components/Utils/utils.js";
import environment from "../../environment/environment";
import { useTranslation } from "react-i18next";
const server = `${environment.SERVER}`;

const useStyles = makeStyles(styles);
const useStylesPrincipal = makeStyles(stylePrincipal);
const useStylesAlert = makeStyles(stylesAlerts);
export default function Dashboard() {
  const wizardRef = useRef(null);
  const { t, i18n } = useTranslation();
  const classesPrincipal = useStylesPrincipal();
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const isKiosko = checkIfIsKiosko();
  const history = useHistory();
  const dispatch = useDispatch();
  const [orders, setOrders] = useState([]);
  const [ordenes, setOrdenes] = useState([]);
  const isInactive = useInactivity();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));
  const [totalRows, setTotalRows] = useState(0);
  const [currentOffset, setCurrentOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const [isAgent, setIsAgent] = useState(false);
  const [allPolicies, setAllPolicies] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [isOpenErrors, setIsOpenErrors] = useState(false);
  const [messageToast, setMessageToast] = useState("");
  const [currentOrderId, setCurrentOrderId] = useState(0);
  const [currentName, setCurrentName] = useState("");
  const [csrEmail, setCsrEmail] = useState("");
  const [alert, setAlert] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [currentQuoteId, setCurrentQuoteId] = useState(0);
  const rowsForPage = 10;

  useEffect(() => {
    getQuotes(currentOffset);
  }, [dispatch, isAgent, allPolicies]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setOrdenes([]);
      getQuotes(currentOffset);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  const getQuotes = async (offset) => {
    setLoading(true);
    const data = {
      start: offset,
      length: 50,
      agent: isAgent,
      allyears: allPolicies,
      search: {
        value: search,
        regex: false,
      },
    };

    const resultSubmit = await dispatch(getQuotesByClient(data));
    setOrdenes(resultSubmit.payload.data);
    setTotalRows(resultSubmit.payload.data.length);
    setCurrentOffset(offset);
    setLoading(false);
  };

  const deleteQuote = async (id) => {
    const resultSubmit = await dispatch(deleteQuoteAPI({ id: id }));
    closeModal();
    getQuotes(currentOffset);
  };

  const closeModal = () => {
    setIsOpenErrors(false);
    setCurrentName("");
    setCurrentOrderId(0);
    setCsrEmail("");
    setEmail("");
    setAlert(false);
    setMessageToast("");
  };

  const sendEmail = async () => {
    const data = {
      orderid: currentOrderId,
      email: email,
      csr_email: csrEmail,
      uri: "/guest/summary/" + currentOrderId,
      to_name: currentName,
    };

    const resultSubmit = await dispatch(sendEmailAgent(data));
    setMessageToast(resultSubmit.payload.message);
    console.log(resultSubmit.payload.result);
    if (resultSubmit.payload.result) {
      closeModal();
      setModalSuccess(true);
    }
  };

  const setMyPolicies = () => {
    setAllPolicies(false);
    setIsAgent(true);
  };
  const setPolicies = () => {
    setAllPolicies(false);
    setIsAgent(false);
  };
  const setAllYearsMyPolicies = () => {
    setAllPolicies(true);
    setIsAgent(true);
  };
  const setAllYearsAllPolicies = () => {
    setAllPolicies(true);
    setIsAgent(false);
  };
  const classes = useStyles();
  const classesAlerts = useStylesAlert();

  // Hooks
  const redesign = process.env.REACT_APP_REDESIGN;
  const isRedesign = redesign === "true" ? true : false;
  const url = redesign === "true" ? "/guestRedesing" : "/admin/wizard";

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    if (name === "search") {
      setSearch(value);
    }
    if (name === "email") {
      setSearch(value);
    }
    if (name === "csr") {
      setCsrEmail(value);
    }
  };

  const showAlertConfirm = (id) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Do you want delete this quote?"
        onConfirm={() => deleteQuote(id)}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classesAlerts.button + " " + classesAlerts.success}
        cancelBtnCssClass={classesAlerts.button + " " + classesAlerts.danger}
        confirmBtnText="Yes"
        cancelBtnText="Cancel"
        showCancel
      ></SweetAlert>
    );
  };

  const printQuote = async (quoteId) => {
    const resultSubmit = await dispatch(print({ quoteId: quoteId }));
    if (resultSubmit.payload) {
      let a = document.createElement("a");
      a.href = "data:application/pdf;base64," + resultSubmit.payload.data.file;
      a.download = `${resultSubmit.payload.data.name}.pdf`;
      a.click();
    } else {
      let mensaje = "\n";
      for (const key in resultSubmit.payload.message) {
        mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
      }
    }
  };

  const fillButtons = (order) => {
    const styleButton = {
      cursor: "pointer",
      padding: "0px !important",
    };
    return (
      <>
        <GridContainer>
          <GridItem
            onClick={() => history.push(`/guest/en/${order.id}`)}
            md={2}
            style={styleButton}
          >
            <Tooltip title="View Quote" placement="top" arrow>
              <Edit style={{ color: "#13816F" }} fontSize="small"></Edit>
            </Tooltip>
          </GridItem>
          <GridItem
            onClick={() => printQuote(order.id)}
            md={2}
            style={styleButton}
          >
            <Tooltip title="Print Quote" placement="top" arrow>
              <DescriptionIcon style={{ color: "#13816F" }} fontSize="small"></DescriptionIcon>
            </Tooltip>
          </GridItem>
          <GridItem
            onClick={() => {
              setCurrentOrderId(order.id);
              setMessageToast("Do you want delete this quote?");
              setAlert(true);
            }}
            md={2}
            style={styleButton}
          >
            <Tooltip title="Delete Quote" placement="top" arrow>
              <Delete style={{ color: "#13816F" }} fontSize="small"></Delete>
            </Tooltip>
          </GridItem>
        </GridContainer>
      </>
    );
  };

  const calculateExpirationText = (orderExpirationDate) => {
    if (orderExpirationDate != null && orderExpirationDate != "") {
      let newDateExpiration = orderExpirationDate.split("-");
      const fechaActual = new Date();
      const fechaExpiracion = new Date(
        newDateExpiration[2] +
          "-" +
          newDateExpiration[0] +
          "-" +
          newDateExpiration[1]
      );
      const diferenciaMilisegundos = fechaExpiracion - fechaActual;
      const diferenciaDias = diferenciaMilisegundos / (1000 * 60 * 60 * 24);
      if (diferenciaDias < 0) {
        return "Expired";
      } else {
        return "Active";
      }
    }
  };
  const handleChangePage = (currentPage) => {
    if ((currentPage * rowsForPage) % 50 === 0) {
      getPolicies(currentPage * rowsForPage);
    }
  };

  const getActivePolicies = () => {
    let ordenesT = [];
    let daysLeft = 0;
    ordenes.forEach((order, index) => {
      const status = calculateExpirationText(order.expiration_date);
      const rowIndex = currentOffset + index + 1;
      ordenesT[rowIndex] = [
        order.quote_number,
        {
          name: order.producer_code,
          className: isXs || isSm ? classes.displayNone : "",
        },
        {
          name: order.created_date,
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: order.last_name,
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: order.first_name,
          className: isXs || isSm || isMd ? classes.displayNone : "",
        },
        {
          name: order.year,
          className: isXs || isSm ? classes.displayNone : "",
        },
        {
          name: order.vehicle_make_name ? order.vehicle_make_name : order.make,
          className: isXs || isSm ? classes.displayNone : "",
        },
        {
          name: order.vehicle_model_name
            ? order.vehicle_model_name
            : order.model,
          className: isXs || isSm ? classes.displayNone : "",
        },
        fillButtons(order),
      ];
    });
    return (
      <GridContainer>
        <GridItem xs={12} style={{ marginLeft: "20px" }}>
          <GridContainer style={{ marginBottom: "20px" }}>
            <GridItem xs={12}>
              <Table
                tableHead={[
                  t("quotes.quoteNumber"),
                  {
                    name: t("quotes.producer"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  {
                    name: t("quotes.dateSaved"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("quotes.lastName"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("quotes.firstName"),
                    className: isXs || isSm || isMd ? classes.displayNone : "",
                  },
                  {
                    name: t("quotes.year"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  {
                    name: t("quotes.make"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  {
                    name: t("quotes.model"),
                    className: isXs || isSm ? classes.displayNone : "",
                  },
                  t("quotes.options"),
                ]}
                tableData={ordenesT}
                customCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customClassesForCells={[0, 4, 5]}
                customHeadCellClasses={[
                  classes.center,
                  classes.right,
                  classes.right,
                ]}
                customHeadClassesForCells={[0, 4, 5]}
                rowsPerPage={10}
                totalRows={totalRows}
                changePage={handleChangePage}
                loading={loading}
              />

              <CustomModal
                title="Send Email"
                isOpen={isOpenErrors}
                onClose={closeModal}
                privacy={false}
                id={"emailModal"}
              >
                <GridContainer>
                  <GridItem xs={12}>
                    <p style={{ color: "red" }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: sanatizeMessageHtml(messageToast),
                        }}
                      ></div>
                    </p>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={1}></GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("step2.email")}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        name: "email",
                        id: "email",
                        value: email,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t("step4.csrInitials")}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        name: "csr",
                        id: "csr",
                        value: csrEmail,
                        onChange: handleFormChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      <GridItem xs={0} sm={0} md={2}></GridItem>
                      <GridItem xs={12} sm={12} md={8}>
                        <Button
                          id="sendEmail"
                          type="submit"
                          variant="green"
                          onClick={() => {
                            sendEmail();
                          }}
                          block
                        >
                          Send
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </CustomModal>
              <CustomModal
                title="Success"
                isOpen={modalSuccess}
                onClose={() => {
                  setModalSuccess(false);
                  setMessageToast("");
                }}
                privacy={false}
                id={"successModal"}
              >
                <GridContainer>
                  <GridItem xs={12}>
                    <h4>{messageToast}</h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      <GridItem xs={0} sm={0} md={2}></GridItem>
                      <GridItem xs={12} sm={12} md={8}>
                        <Button
                          id="successButton"
                          type="submit"
                          variant="green"
                          onClick={() => {
                            setModalSuccess(false);
                            setMessageToast("");
                          }}
                          block
                        >
                          Ok
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </CustomModal>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    );
  };

  const gridPolicies = () => {
    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer
              style={{ padding: "20px 0px 40px 0px" }}
              justify="center"
            >
              <GridContainer>
                <GridItem xs={12} md={12}>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Card>
                      <CardHeader>
                        <div
                          className={`${classesPrincipal.title} ${classesPrincipal.black}`}
                        >
                          {t("quotes.myQuotes")}{" "}
                        </div>
                        <GridContainer>
                          {ordenes && (
                            <>
                              <GridItem xs={12} style={{ marginTop: "15px" }}>
                                <GridContainer>
                                  <GridItem xs={0} sm={0} md={9}></GridItem>
                                  <GridItem xs={12} sm={12} md={3}>
                                    <CustomInput
                                      labelText={t("step2.search")}
                                      formControlProps={{
                                        fullWidth: true,
                                        className:
                                          classes.customFormControlClasses,
                                      }}
                                      inputProps={{
                                        name: "search",
                                        id: "search",
                                        value: search,
                                        onChange: handleFormChange,
                                      }}
                                    />
                                  </GridItem>
                                </GridContainer>
                              </GridItem>
                              <GridItem xs={12} style={{ marginTop: "15px" }}>
                                {getActivePolicies()}
                              </GridItem>
                            </>
                          )}
                        </GridContainer>
                      </CardHeader>
                    </Card>
                  </GridItem>
                </GridItem>
              </GridContainer>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    );
  };

  return (
    <>
      {gridPolicies()}
      <CustomModal
        title="Delete Quote"
        isOpen={alert}
        onClose={closeModal}
        privacy={false}
        id={"emailModal"}
      >
        <GridContainer>
          <GridItem xs={12}>
            <p style={{ color: "red" }}>
              <h4
                dangerouslySetInnerHTML={{
                  __html: sanatizeMessageHtml(messageToast),
                }}
              ></h4>
            </p>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={1}></GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer>
              <GridItem xs={0} sm={0} md={1}></GridItem>
              <GridItem xs={12} sm={12} md={5}>
                <Button
                  id="deleteQuote"
                  type="submit"
                  variant="green"
                  onClick={() => {
                    deleteQuote(currentQuoteId);
                  }}
                  block
                >
                  Delete
                </Button>
              </GridItem>
              <GridItem xs={12} sm={12} md={5}>
                <Button
                  id="closeQuote"
                  type="submit"
                  variant="red"
                  onClick={() => {
                    closeModal();
                  }}
                  block
                >
                  Close
                </Button>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </CustomModal>
    </>
  );
}
